import * as Sentry from "@sentry/react";

const setupSentry = () => {
  fetch("/settings")
    .then((response) => {
      return response.json();
    })
    .then((settings) => {
      if (!settings?.sentryConfig.enabled || !settings?.sentryConfig.dsn) {
        return;
      }

      Sentry.init({
        dsn: settings.sentryConfig.dsn,
        integrations: [
          Sentry.browserTracingIntegration(),
          Sentry.replayIntegration({
            maskAllText: false,
          }),
        ],
        tracesSampleRate: 0.5,
        environment: settings.environment,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
      });
    });
};

export { setupSentry };
